<!-- eslint-disable -->
<template>
    <div class="add-quiz-contain">
        <h2 class="header">添加quiz基本信息</h2>
        <el-form ref="formRef" :model="form" label-position="right" label-width="160px" size="small">
            <el-row>
                <el-col :span="20">
                    <el-form-item label="分类：" prop="quiz_category" :rules="rules.quizCategory">
                        <el-select
                            v-model="form.quiz_category"
                            placeholder="选择分类"
                        >
                            <el-option
                                v-for="item in CATEGORY_LIST"
                                :key="item.category_id"
                                :label="item.category_name"
                                :value="item.category_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="10">
                    <el-form-item label="Tag1：" prop="tag_one" :rules="rules.tagOne">
                        <el-select
                            v-model="form.tag_one"
                            placeholder="选择tag1"
                        >
                            <el-option
                                v-for="item in QUIZ_TAG_TREE"
                                :key="item.tag_id"
                                :label="item.tag_one_name"
                                :value="item.tag_id"
                                @click.native="handleTagOneChange(item)"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="Tag2：" prop="tag_two">
                        <el-select
                            v-model="form.tag_two"
                            placeholder="选择tag2"
                        >
                            <el-option
                                v-for="item in tag_two_list"
                                :key="item.tag_id"
                                :label="item.tag_two_name"
                                :value="item.tag_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item class="my-border-form padding-form" label="Tag3(自定义)：">
                        <el-tag
                            :key="tag"
                            v-for="tag in form.tag_three_custom"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm"
                            >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Tag3(自定义)</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="标题：" prop="quiz_title" :rules="rules.quizTitle">
                        <el-input
                            v-model="form.quiz_title"
                            placeholder="请输入标题"
                            @blur="generateUrlTitle()"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item
                        class="my-border-form"
                        label="url_title："
                    >
                        <span class="url-title">{{ form.url_title }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item class="my-border-form padding-form" label="banner图：" prop="banner_image" :rules="rules.image">
                        <el-input v-model="form.banner_image" style="display:none"></el-input>
                        <el-upload
                            action="#"
                            list-type="picture-card"
                            accept=".jpg, .jpeg, .png"
                            :auto-upload="false"
                            :class="{hide: hideUpload}"
                            :file-list="thumbnail"
                            :on-change="handleChange"
                        >
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}" class="el-upload-list-item-thumbnail">
                                <img :src="file.url" alt />
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="intro页文案：" prop="quiz_intro_info">
                        <el-input
                            type="textarea"
                            v-model="form.quiz_intro_info"
                            placeholder="请输入intro页文案"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-card v-for="(question_item, index) in form.question_list" :key="index">
                <el-row>
                    <el-col :span="20">
                        <el-form-item
                            :label="`题目${index + 1}：`"
                            :prop="`question_list[${index}].quiz_question`"
                            :rules="rules.quizQuestion"
                        >
                            <el-input
                                v-model="form.question_list[index].quiz_question"
                                placeholder="请输入题目"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button
                            class="remove-question"
                            type="info"
                            @click="removeQuestion(index)"
                            size="small"
                        >删除</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item
                            label="题目对应图片："
                            :prop="`question_list[${index}].image`"
                            :rules="rules.image"
                        >
                            <el-input
                                v-model="form.question_list[index].image"
                                style="display:none"
                            ></el-input>
                            <el-upload
                                action="#"
                                :file-list="form.question_list[index].fileList"
                                :auto-upload="false"
                                list-type="picture"
                                :on-change="
                                    (file, fileList) => {
                                        return uploadImage(file, fileList, index);
                                    }
                                "
                                :on-exceed="handleExceed"
                                :on-remove="
                                    (file, fileList) => {
                                        return removeFile(file, fileList, index);
                                    }
                                "
                                :limit="1"
                                accept=".jpg, .jpeg, .png"
                                >
                                <el-button size="mini" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item
                            label="题目选项："
                            :prop="`question_list[${index}].option_list_string`"
                            :rules="rules.OptionListString"
                        >
                            <el-input
                                type="textarea"
                                v-model="form.question_list[index].option_list_string"
                                placeholder="请输入题目对应选项"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item
                            label="题目选项分数："
                            :prop="`question_list[${index}].option_score_list_string`"
                            :rules="rules.OptionScoreListString"
                        >
                            <el-input
                                type="textarea"
                                v-model="form.question_list[index].option_score_list_string"
                                placeholder="请输入题目选项对应分数"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
            <el-button class="add-quiz-question" type="primary" @click="addQuestion()" size="small">添加quiz题</el-button>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="答案：" prop="quiz_answer_list_string" :rules="rules.quizAnswerListString">
                        <el-input
                            class="answer-textarea"
                            type="textarea"
                            v-model="form.quiz_answer_list_string"
                            placeholder="请输入答案"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="20">
                    <el-form-item label="答案对应分数：" prop="quiz_answer_score_list_string" :rules="rules.quizAnswerScoreListString">
                        <el-input
                            type="textarea"
                            v-model="form.quiz_answer_score_list_string"
                            placeholder="请输入答案对应分数"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row class="btn-row">
            <el-button @click="cancelForm()" size="medium">取消</el-button>
            <el-button type="primary" @click="onSubmit()" size="medium">保存</el-button>
        </el-row>
    </div>
</template>
<!-- eslint-disable -->

<script>
import {CATEGORY_LIST, QUIZ_TAG_TREE} from './initdata';
import {formConvertFormat} from '../../common/tools';

export default {
    name: 'AddQuiz',
    props: {
        editActicleId: {
            type: Number
        }
    },
    data() {
        return {
            CATEGORY_LIST,
            QUIZ_TAG_TREE,
            inputVisible: false, // tag自定义input显示
            inputValue: '',
            form: {
                quiz_category: '', // quiz分类
                tag_one: '', // tag1
                tag_two: '', // tag2
                tag_three_custom: [], // tag3自定义
                quiz_title: '', // quiz标题
                url_title: '', // quiz seo 跳转 url_title
                banner_image: '', // quiz banner图 base64
                quiz_intro_info: '', // quiz intro页文案
                question_list: [
                    {
                        quiz_question: '', // quiz问题
                        image: '', // quiz对应图片
                        fileList: [], // 记录上传图片的信息
                        option_list_string: '', // 选项
                        option_score_list_string: '' // 选项对应分数
                    }
                ],
                quiz_answer_list_string: '', // quiz答案
                quiz_answer_score_list_string: '' // quiz答案对应分数
            },
            tag_two_list: [], // tag2下拉框对应数组
            hideUpload: false, // 控制上传banner缩略图入口的隐藏与显示
            thumbnail: [], // banner缩略图文件列表
            rules: {
                // 校验规则
                quizCategory: [
                    {
                        required: true,
                        message: '分类不可为空',
                        trigger: 'change'
                    }
                ],
                tagOne: [
                    {
                        required: true,
                        message: 'quiz tag1不可为空',
                        trigger: 'change'
                    }
                ],
                quizTitle: [
                    {
                        required: true,
                        message: 'quiz标题不可为空',
                        trigger: 'blur'
                    }
                ],
                image: [
                    {
                        required: true,
                        message: '请上传图片',
                        trigger: 'change'
                    }
                ],
                quizQuestion: [
                    {
                        required: true,
                        message: 'quiz题目不可为空',
                        trigger: 'blur'
                    }
                ],
                OptionListString: [
                    {
                        required: true,
                        message: '题目选项不可为空',
                        trigger: 'blur'
                    }
                ],
                OptionScoreListString: [
                    {
                        required: true,
                        message: '题目选项分数不可为空',
                        trigger: 'blur'
                    }
                ],
                quizAnswerListString: [
                    {
                        required: true,
                        message: 'quiz答案不可为空',
                        trigger: 'blur'
                    }
                ],
                quizAnswerScoreListString: [
                    {
                        required: true,
                        message: '答案分数不可为空',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    watch: {
        editActicleId: {
            handler(newVal) {
                if (newVal) {
                    this.$axios(this.path.getQuizInfo(newVal))
                        .then(res => {
                            this.form = this.formConvertFormat(res.data);
                            // 根据tag1 id获取tag 2
                            Object.keys(this.QUIZ_TAG_TREE).forEach(item => {
                                if (this.QUIZ_TAG_TREE[item].tag_id === this.form.tag_one) {
                                    this.tag_two_list = this.QUIZ_TAG_TREE[item].tag_two;
                                }
                            });
                            // banner图片显示
                            this.thumbnail.push({
                                url: this.form.banner_image
                            });
                            this.hideUpload = true;
                        });
                }
            },
            immediate: true
        }
    },
    methods: {
        formConvertFormat,
        // 移除tag3标签
        handleClose(tag) {
            this.form.tag_three_custom.splice(this.form.tag_three_custom.indexOf(tag), 1);
        },
        // 显示输入tag3标签
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 确定tag3标签
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.form.tag_three_custom.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
            console.log(this.form.tag_three_custom);
        },
        // 上传banner图
        handleChange(file, fileList) {
            let f = file.raw;
            if (f.size > 16777216) {
                // 限制文件的大小
                this.$Message.error(f.name + '大小超过16M!');
                // 超过大小将文件清空
                f = null;
                this.form.banner_image = '';
                this.thumbnail = [];
            } else {
                // 读取文件的字符流
                const reader = new FileReader();
                // 将文件读取为 DataURL 以data:开头的字符串
                reader.readAsDataURL(f);
                reader.onload = e => {
                    // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
                    const code = e.target.result;
                    this.form.banner_image = code;
                    this.thumbnail = fileList;
                    this.hideUpload = this.thumbnail.length >= 1;
                };
            }
            return false;
        },
        // 移除banner图
        handleRemove() {
            this.thumbnail = [];
            this.form.banner_image = '';
            this.hideUpload = false;
        },
        // 上传题目对应图片
        uploadImage(file, fileList, index) {
            let f = file.raw;
            if (f.size > 16777216) {
                // 限制文件的大小
                this.$Message.error(f.name + '大小超过16M!');
                // 超过大小将文件清空
                f = null;
                this.removeFile(file, fileList, index);
            } else {
                // 读取文件的字符流
                const reader = new FileReader();
                // 将文件读取为 DataURL 以data:开头的字符串
                reader.readAsDataURL(f);
                reader.onload = e => {
                    // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
                    const code = e.target.result;
                    this.form.question_list[index].image = code;
                    this.form.question_list[index].fileList = fileList;
                };
            }
            return false;
        },
        // 移除quiz题目对应图片
        removeFile(_, fileList, index) {
            this.form.question_list[index].image = '';
            this.form.question_list[index].fileList = [];
        },
        // 上传图片个数超出限制回调
        handleExceed(_, fileList) {
            if (fileList.length >= 1) {
                this.$message.warning('只允许上传一张图片');
            }
        },
        // 选择标签一联动标签二
        handleTagOneChange(item) {
            this.tag_two_list = item.tag_two;
            this.form.tag_two = '';
        },
        // 添加quiz题目
        addQuestion() {
            let obj = {
                quiz_question: '',
                image: '', // base64
                fileList: [], // 记录上传图片的信息
                option_list_string: '', // 选项
                option_score_list_string: '' // 选项对应分数
            };
            this.form.question_list.push(obj);
        },
        // 移除quiz某个题目
        removeQuestion(index) {
            if (this.form.question_list.length > 1) {
                this.$confirm('您确认要删除该题目吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.question_list.splice(index, 1);
                }).catch(() => {
                });
            } else {
                this.$message.warning('至少保留一项');
            }
        },
        // 生成url_title
        generateUrlTitle() {
            let stringArr = [];
            this.form.quiz_title.trim().split(' ').forEach(item => {
                if ((item.trim().replace(/[^a-zA-Z0-9]/g, ''))) {
                    stringArr.push((item.trim().replace(/[^a-zA-Z0-9]/g, '')));
                }
            });
            this.form.url_title = stringArr.join('-');
        },
        // 取消表单提交
        cancelForm() {
            this.$confirm('您确认要舍弃已编辑的内容吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('toMenuList', 'quizList');
            }).catch(() => {
            });
        },
        // 表单提交
        onSubmit() {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.form.question_list.forEach(item => {
                        delete item.fileList;
                    });
                    console.log(this.form);
                    let addEditFun = this.editActicleId ? this.path.editArticleSave : this.path.addArticle;
                    this.$axios(addEditFun(this.form)).then(res => {
                        this.$message.success({
                            message: res.msg,
                            duration: 1000,
                            onClose: () => {
                                this.$emit('toMenuList', 'quizList');
                            }
                        });
                    });
                } else {
                    this.$message.warning('请填写必填项');
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.add-quiz-contain {
    height: calc(100vh - 80px);
    text-align: left;
    .header {
        background: #efefef;
        line-height: 44px;
        font-weight: normal;
        font-size: 16px;
        padding-left: 16px;
        margin-bottom: 12px;
    }
    .el-form {
        max-height: calc(100% - 100px);
        overflow: auto;
        .button-new-tag {
            height: 32px;
            line-height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        }
        .input-new-tag {
            width: 90px;
            vertical-align: bottom;
        }
        /deep/.my-border-form {
            .el-form-item__content {
                border: 1px solid #eee;
                border-radius: 4px;
                padding: 0 15px;
            }
            &.padding-form .el-form-item__content {
                padding: 8px 15px;
            }
        }
        .el-tag {
            margin-right: 10px;
        }
        .el-select {
            width: 100%;
        }
        .el-textarea {
            /deep/.el-textarea__inner {
                min-height: 160px !important;
            }
            &.answer-textarea /deep/.el-textarea__inner {
                height: 240px;
            }
        }
        .el-upload-list-item-thumbnail {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: center;
        }
        /deep/.hide .el-upload--picture-card {
            display: none;
        }
        .add-quiz-question {
            margin-left: 24px;
            margin-bottom: 24px;
        }
        .el-card {
            width: 96%;
            margin: 0 auto 12px 24px;
            position: relative;
            .remove-question {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
        .url-title {
            color: #e6a23c;
        }
    }
    .btn-row {
        position: absolute;
        right: 20px;
        bottom: 16px;
        .el-button {
            width: 120px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/add-quiz/index.vue